<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
function updateCartOffers() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(data => {
      const container = document.getElementById('dynamic-offers');
      const countdownBox = document.getElementById('CartCountdown-{{ section.id }}');

      const cartTotal = data.total_price / 100;
      const itemCount = data.item_count;

      // Show/hide countdown box based on cart item count
      if (countdownBox) {
        if (itemCount > 0) {
          countdownBox.style.display = 'flex';
        } else {
          countdownBox.style.display = 'none';
          return; // stop here if cart is empty
        }
      }

      let messages = [];

      // Offer 1: ₹300 OFF on ₹2100
      const threshold1 = 2100;
      if (cartTotal >= threshold1) {
        messages.push("✅ ₹300 OFF + Free Shipping will be auto-applied at checkout!");
      } else if (cartTotal >= 1800) {
        messages.push(`💸 Add ₹${threshold1 - cartTotal} more to unlock ₹300 OFF + Free Shipping`);
      }

      // Offer 2: Buy 2 Get 1 Free – Plain Tees
      if (itemCount >= 2) {
        messages.push("🎁 Buy 2 Plain Tees → Get 1 Slim Fit FREE");
      } else {
        messages.push(`🛍️ Add ${2 - itemCount} more item(s) to unlock Buy 2 Get 1 FREE`);
      }

      // Offer 3: Buy 3, Get 1 FREE – Oversized Tees
      if (itemCount >= 3) {
        messages.push("🎉 Buy 3 Oversized Tees → Get 1 FREE + 1 Mystery Gift!");
      } else {
        messages.push(`🎁 Add ${3 - itemCount} more Oversized Tees to unlock Buy 3 Get 1 FREE + Mystery Gift`);
      }

      if (container) {
        container.innerHTML = messages.map(msg => `<p style="margin: 5px 0;">${msg}</p>`).join('');
      }
    });
}

// --- Initialize on load and listen for changes ---
document.addEventListener('DOMContentLoaded', () => {
  updateCartOffers();

  document.addEventListener("change", function (e) {
    if (e.target.matches('input[name="updates[]"]')) {
      setTimeout(updateCartOffers, 800);
    }
  });

  const cartForm = document.querySelector('form[action="/cart"]');
  if (cartForm) {
    const observer = new MutationObserver(updateCartOffers);
    observer.observe(cartForm, { childList: true, subtree: true });
  }
});

// for size chart by bsquare
// -------------------------------
// 1. Tab switching
// -------------------------------
document.querySelectorAll(".size-chart-tabs li").forEach(tab => {
  tab.addEventListener("click", function () {
    // remove active class from all tabs and panels
    document.querySelectorAll(".size-chart-tabs li").forEach(t => t.classList.remove("active"));
    document.querySelectorAll(".size-chart-panel").forEach(p => p.classList.remove("active"));

    this.classList.add("active");
    const target = this.dataset.tab;
    const panel = document.getElementById("tab-" + target);
    if (panel) panel.classList.add("active");

    // Apply unit toggle for any tables in this panel
    const inchTable = panel.querySelector(".table-inch");
    const cmTable = panel.querySelector(".table-cm");
    const unitToggle = panel.querySelector(".size-unit-toggle span.active");

    if (unitToggle) {
      if (unitToggle.dataset.unit === "inch") {
        if (inchTable) inchTable.style.display = "block";
        if (cmTable) cmTable.style.display = "none";
      } else {
        if (inchTable) inchTable.style.display = "none";
        if (cmTable) cmTable.style.display = "block";
      }
    } else {
      // default show inch table
      if (inchTable) inchTable.style.display = "block";
      if (cmTable) cmTable.style.display = "none";
    }
  });
});


// -------------------------------
// 2. Unit toggle (Inch / CM)
// -------------------------------
document.querySelectorAll(".size-unit-toggle span").forEach(unit => {
  unit.addEventListener("click", function () {
    // toggle active class
    this.closest(".size-unit-toggle").querySelectorAll("span").forEach(u => u.classList.remove("active"));
    this.classList.add("active");

    // find parent tab panel
    const panel = this.closest(".size-chart-panel");
    if (!panel) return;

    const inchTable = panel.querySelector(".table-inch");
    const cmTable = panel.querySelector(".table-cm");

    if (this.dataset.unit === "inch") {
      if (inchTable) inchTable.style.display = "block";
      if (cmTable) cmTable.style.display = "none";
    } else {
      if (inchTable) inchTable.style.display = "none";
      if (cmTable) cmTable.style.display = "block";
    }
  });
});

// -------------------------------
// 3. Highlight row function
// -------------------------------
function highlightRow(tableSelector, value) {
  document.querySelectorAll(tableSelector + " tbody tr").forEach(tr => {
    tr.classList.remove("selected");
    const radio = tr.querySelector("input[type='radio']");
    if (radio && radio.value === value) {
      tr.classList.add("selected");
      radio.checked = true;
    }
  });
}

// -------------------------------
// 4. Sync two tables (Inch <-> CM)
// -------------------------------
function syncTables(sourceSelector, targetSelector) {
  const sourceRadios = document.querySelectorAll(sourceSelector + " input[type='radio']");
  const targetRadios = document.querySelectorAll(targetSelector + " input[type='radio']");

  sourceRadios.forEach(radio => {
    radio.addEventListener("change", function () {
      const value = this.value;

      // Highlight selected row in both tables
      highlightRow(sourceSelector, value);
      highlightRow(targetSelector, value);

      // Sync target table radio
      targetRadios.forEach(tr => {
        if (tr.value === value) tr.checked = true;
      });

      // Update product variant
      const variantId = this.dataset.variantId;
      if (variantId) {
        const productRadio = document.querySelector(`.product-form__radio[data-variant-id='${variantId}']`);
        if (productRadio) {
          productRadio.checked = true;
          productRadio.dispatchEvent(new Event('change'));
        }
      }
    });
  });
}

// Apply syncing both ways
syncTables(".table-inch", ".table-cm");
syncTables(".table-cm", ".table-inch");

// -------------------------------
// 5. Update size chart based on selected product variant
// -------------------------------
function updateSizeChart(selectedVariantId) {
  document.querySelectorAll(".size-table-wrapper table tbody tr").forEach(row => {
    const radio = row.querySelector("input[type='radio']");
    if (!radio) return;

    if (radio.dataset.variantId == selectedVariantId) {
      row.classList.add("selected");
      radio.checked = true;
    } else {
      row.classList.remove("selected");
      radio.checked = false;
    }
  });
}

// On page load
// document.addEventListener("DOMContentLoaded", function () {
//   const selectedVariant = document.querySelector(".product-form__radio:checked");
//   if (selectedVariant) updateSizeChart(selectedVariant.dataset.variantId);
// });

// Function to handle size chart update on variant change
function onVariantChange(event) {
  const selectedVariant = event.target;
  if (selectedVariant && selectedVariant.dataset.variantId) {
    updateSizeChart(selectedVariant.dataset.variantId);

    // Sync highlighted row in tables
    const value = selectedVariant.value;
    highlightRow(".table-inch", value);
    highlightRow(".table-cm", value);
  }
}

// Listen for variant radio changes
document.querySelectorAll(".product-form__radio").forEach(radio => {
  radio.addEventListener("change", onVariantChange);
});

// On page load, highlight selected variant
document.addEventListener("DOMContentLoaded", function () {
  const selectedVariant = document.querySelector(".product-form__radio:checked");
  if (selectedVariant) {
    updateSizeChart(selectedVariant.dataset.variantId);
    const value = selectedVariant.value;
    highlightRow(".table-inch", value);
    highlightRow(".table-cm", value);
  }
});



